const REACT_APP_BASE_URL = "https://salesmhc.modena.com/";
//const REACT_APP_BASE_URL = "https://sfadev.modena.com/";

export { REACT_APP_BASE_URL };